import { Component, h, Host, Prop, Watch, Element, State, Event, EventEmitter, Listen } from '@stencil/core';
import {IntersectionObserverAvailable} from '../../../utils/availability';
import { componentOnReady, raf } from '../../../utils/component.utils';

@Component({
  tag: 'c7-img',
  styleUrl: 'image.scss',
  shadow: true
})
export class Image {

  @Element() element!: HTMLElement;

  @Listen('resize', {target: 'window'})
  onResize(){
    this.registerIntersectionObserver();
  }

  @Prop({reflect: true}) src?: string;
  @Watch('src')
  onSrcChange() {
    this.load();
    //this.registerIntersectionObserver();
  }

  @Prop() alt?: string;

  @Prop() sync: boolean = false;

  @Prop() fit?: 'cover' | 'contain' | 'scale-down';

  @Event() imgWillLoad!: EventEmitter<void>;

  @Event() imgDidLoad!: EventEmitter<void>;

  @Event() imgError!: EventEmitter<void>;

  @State() loadSrc?: string;

  @State() loadError?: () => void;

  @State() currentFit?: 'cover' | 'contain' | 'scale-down';

  private io: IntersectionObserver;

  private _imgRef: HTMLImageElement;

  private onLoad = () => {
    this.imgDidLoad.emit();

    if(!this.fit) {
      const {naturalWidth, naturalHeight} = this._imgRef;
      const ar = naturalWidth / naturalHeight;

      this.currentFit = ar < 1.2 || ar > 2 ? 'contain' : 'cover';
    }
  };

  private onError = () => {
    this.imgError.emit();
  }

  componentWillLoad() {
    if (this.fit) this.currentFit = this.fit;
  }

  componentDidLoad() {
    //this.registerIntersectionObserver();
    /*this.load();*/
    raf(() => {
      if(this.element.clientWidth == 0)
      {
        this.componentDidLoad();
      }
      else{
        this.load();
      }
    })

  }

  private registerIntersectionObserver() {

    if(!this.src) {
      return;
    }

    if (IntersectionObserverAvailable && !this.sync) {
      this.unregisterIntersectionObserver();
      this.io = new IntersectionObserver(data => {
        if (data[data.length - 1].isIntersecting) {
          this.load();
          this.unregisterIntersectionObserver();
        }
      });

      this.io.observe(this.element);
    } else {
      setTimeout(() => this.load(), 200);
    }
  }

  private unregisterIntersectionObserver() {
    if(this.io) {
      this.io.disconnect();
      this.io = undefined;
    }
  }

  private load() {
    this.loadError = this.onError;
    this.loadSrc = this.src ? `${this.src}${this.src.includes('?') ? '&' : '?'}size=${Math.ceil(this.element.clientWidth / 100) * 100 * 2}&webp=true` : null;
    this.imgWillLoad.emit();
  }

  render(){

    return (
      <Host class={{
        ['c7-img']: true,
        [`c7-img-fit-${this.currentFit}`]: true,
      }}>
        <img
          decoding="async"
          loading="lazy"
          src={this.loadSrc}
          alt={this.alt || ''}
          onLoad={this.onLoad}
          onError={this.loadError}
          ref={(el: HTMLImageElement) => this._imgRef = el}
          part="image" />
      </Host>
    )
  }

}
